const AUDIO_FILE = /\.(mp3|aac|ogg|opus|m4a|m3u8)(\?|$)/i
const PLAYLIST_FILE = /\.(m3u|pls)(\?|$)/i
const STREAM_HINT = /stream|listen|aac|mp3|ice|radio|play|audio/i

function withProtocol(raw: string): string {
  const value = raw.trim()
  if (!value) return ''
  if (/^https?:\/\//i.test(value)) return value
  return `https://${value}`
}

function isDirectoryPage(url: string): boolean {
  try {
    const host = new URL(url).hostname.replace(/^www\./, '').toLowerCase()
    return host === 'radios.net' || host.endsWith('.radios.net') || host === 'radios.net.br' || host === 'radios.com.br'
  } catch {
    return false
  }
}

function firstHttpUrl(text: string): string {
  const matches = text.match(/https?:\/\/[^\s"'<>\\]+/gi) || []
  const ranked = matches
    .map((item) => item.replace(/[),.;]+$/, ''))
    .filter((item) => !/radios\.net|radios\.com\.br|facebook|instagram|youtube|google|apple/i.test(item))
  const stream = ranked.find((item) => STREAM_HINT.test(item) || AUDIO_FILE.test(item) || PLAYLIST_FILE.test(item) || /:\d{2,5}\//.test(item))
  return stream || ranked[0] || ''
}

function parsePlaylist(text: string): string {
  const fileLine = text.match(/File\d+=(\S+)/i)
  if (fileLine?.[1]) return fileLine[1].trim()
  const lines = text.split(/\r?\n/).map((line) => line.trim()).filter((line) => line && !line.startsWith('#'))
  return lines.find((line) => /^https?:\/\//i.test(line)) || firstHttpUrl(text)
}

async function readRemote(url: string): Promise<string> {
  try {
    const direct = await fetch(url, { method: 'GET' })
    if (direct.ok) return direct.text()
  } catch (error) {
    console.error('Leitura direta do link da rádio bloqueada:', error)
  }

  const proxied = await fetch(`https://api.allorigins.win/raw?url=${encodeURIComponent(url)}`)
  if (!proxied.ok) throw new Error(`HTTP ${proxied.status}`)
  return proxied.text()
}

export async function resolveStreamUrl(input?: string): Promise<string> {
  const url = withProtocol(input || '')
  if (!url) return ''
  if (AUDIO_FILE.test(url)) return url

  try {
    if (PLAYLIST_FILE.test(url) || isDirectoryPage(url)) {
      const body = await readRemote(url)
      const extracted = PLAYLIST_FILE.test(url) || body.includes('[playlist]') || body.includes('#EXTM3U')
        ? parsePlaylist(body)
        : firstHttpUrl(body)
      if (extracted && extracted !== url) {
        if (PLAYLIST_FILE.test(extracted) && !AUDIO_FILE.test(extracted)) {
          const nested = parsePlaylist(await readRemote(extracted))
          return nested || extracted
        }
        return extracted
      }
    }
  } catch (error) {
    console.error('Não foi possível resolver o link da rádio:', error)
  }

  return url
}
